import { companyDatas } from "../Content";
import { contacts } from "../ContentContractV2";

export const partners = [
  "1.	Llevar a cabo procesos de debida diligencia que le permita a Galilea realizar las evaluaciones para la selección y contratación de Contrapartes.",
  "2.	Realizar los procesos de vinculación y creación de Contrapartes en los sistemas de información de la Compañía.",
  "3.	Gestionar y controlar los pagos, aspectos tributarios y legales en virtud del desarrollo y ejecución de la relación comercial entre la Contraparte y Galilea.",
  "4.	Generar canales de comunicación entre la Contraparte y Galilea para comunicar sus políticas y procedimientos sobre la forma de hacer negocios o compartir experiencias mutuas respecto al sector que representan.",
  "5.	Adelantar procesos de control y registro contable de las obligaciones contraídas con la Contraparte.",
  "6.	Realizar consultas, auditorias y revisiones derivadas de la relación o ejecución del contrato celebrado entre ambas partes.",
  "7.	Recibir información para gestionar los requerimientos de los usuarios de Galilea respecto a sus productos o servicios (Gestión PQRS).",
  "8.	Generar estadísticas internas que permitan mediar la ejecución del producto o servicio contratado.",
  "9.	Realizar la aplicación de sanciones, clausulas penales o multas asociadas a incumplimientos de algún tipo de obligación contenida en el contrato.",
  "10.	Adelantar procedimientos administrativos y de control interno.",
  "11.	Realizar actividades de gestión administrativa.",
  "12.	Generar o recibir facturas, así como la información necesaria para efectuar el pago de los producto o servicios adquiridos por Galilea.",
  "13.	Gestionar y mantener un histórico de relaciones comerciales activas o inactivas.",
  "14.	Gestionar las medidas y políticas seguridad establecidas por Galilea para la protección de sus activos físicos o electrónicos, así como cualquier gestión que permita la mitigación de riesgos.",
  "15.	Controlar el acceso y salida de personas en las instalaciones, en caso que se cuente con un sistema de vigilancia o de control de ingreso o salida de personal.",
  "16.	Adelantar actividades de comercio electrónico.",
  "17.	Consultar y mantener registro del cumplimiento/incumplimiento de obligaciones financieras.",
  "18.	Adelantar campañas de actualización de datos e información de cambios en el tratamiento de datos personales.",
  "19.	Realizar la verificación de requisitos jurídicos, técnicos y/o financieros de los clientes o proveedores de Galilea.",
  "20.	Realizar el envío de comunicaciones a clientes u otras Contrapartes a nivel general de acuerdo con las autorizaciones brindadas por Galilea para dicho fin.",
  "21.	Remitir o enviar información a terceros relacionada con el objeto social de la organización.",
  "22.	Adelantar investigaciones en caso de presentarse situaciones de riesgo o violaciones a la seguridad física o la ciberseguridad de Galilea.",
  "23.	Adelantar comunicaciones o contacto vía correo electrónico, SMS, teléfono u otro medio con el objetivo de presentar ofertas comerciales para Galilea o terceros.",
  "24.	Gestionar los requisitos o necesidades que nos hayan sido requeridos o se deriven de una relación comercial.",
  "25.	Dar cumplimiento con los requisitos legales para la prevención del lavado de activos y financiación del terrorismo, esto implica la consulta en listas restrictivas vinculantes o no para Colombia.",
  "26.	Realizar la verificación de datos o referencias suministradas con terceros o entidades.",
  "27.	Galilea podrá recolectar datos personales de los empleados de la Contraparte, únicamente para verificar la idoneidad de la persona o personas que estarán a cargo del proyecto o servicio contratado con la Contraparte.",
  "28.	Las demás finalidades establecidas específicamente en las autorizaciones precontractuales, contractuales o post contractuales.",
  "29.	Las demás finalidades licitas de acuerdo con la legislación colombiana.",
];

export const employees = [
  "1.	Dar cumplimiento con las obligaciones que impone la ley laboral Colombiana u obligaciones establecidas por autoridad competente colombiana.",
  "2.	Emitir certificaciones relativas a la relación contractual entre el Empleado y Galilea.",
  "3.	Cumplir a cabalidad con las obligaciones impuestas a Galilea como empleador relativas a las normas de Seguridad y Salud en el trabajo.",
  "4.	Realizar grabaciones a las reuniones virtuales desarrolladas por los trabajadores.",
  "5.	Gestionar y asignar las funciones relativas a su cargo.",
  "6.	Realizar memorandos o llamados de atención, así como desarrollar y aplicar el proceso disciplinario para trabajadores de acuerdo con las normas internas de Galilea.",
  "7.	Establecer comunicación con él, sus parientes o terceros en caso de emergencia.",
  "8.	Llevar a cabo evaluaciones de seguimiento de objetivos, control o seguimiento a los trabajadores.",
  "9.	Tomar fotografías o huellas dactilares que le permita identificar a sus empleados o gestión de control de gestión  de empleados.",
  "10.	Entregar la información a terceros encargados de procesos de evaluación, entrenamiento, certificaciones, capacitaciones y demás procesos requeridos en el desarrollo de la relación contractual.",
  "11.	Verificar, comparar, evaluar las competencias laborales y personales de los trabajadores.",
  "12.	Generar estadísticas y comparativas internas que permita a Galilea realizar segmentación de sus empleados de acuerdo a las funciones y capacidades de cada uno.",
  "13.	Realizar control y seguimiento de las obligaciones laborales, entre ellas el control con el horario de ingreso a la Compañía.",
  "14.	Realizar el pago de la nomina o retribución al trabajador, asi mismo, pagar ante terceros cesantías, ARL, EPS y demás prestaciones sociales.",
  "15.	Realizar la verificación de datos personales proporcionados por el trabajador y sus  referencias personales, familiares o laborales.",
  "16.	Realizar el envío de comunicaciones a nivel general.",
  "17.	Adelantar comunicaciones o contacto vía correo electrónico, SMS, teléfono u otro medio con el objetivo de realizar seguimiento a las labores encomendadas.",
  "18.	Dar cumplimiento al Sistema de Prevención del Riesgo de lavado de activos y financiación del terrorismo, lo cual implica la consulta y reporte en listas restrictivas vinculantes o no para Colombia.",
  "19.	Las demás finalidades establecidas específicamente en las autorizaciones precontractuales, contractuales o post contractuales.",
  "20.	Las demás finalidades licitas de acuerdo con la legislación colombiana.",
];

export const applicants = [
  "1.	Realizar las gestiones administrativas internas y externas para la evaluación de los requisitos del aspirante, así como la adecuación de los requisitos a las necesidades de Galilea.",
  "2.	Enviar diferentes pruebas, escritas, orales, psicológicas, medicas, entre otras, necesarias para el proceso de selección de personal.",
  "3.	Verificación de las referencias personales, familiares o laborales.",
  "4.	Gestión del proceso de vinculación de la persona escogida dentro del proceso de selección.",
  "5.	Almacenar su información del perfil para ser contactado con posterioridad en caso de no ser admitido en el proceso de selección.",
  "6.	Dar cumplimiento al Sistema de Prevención del Riesgo de lavado de activos y financiación del terrorismo, lo cual implica la consulta y reporte en listas restrictivas vinculantes o no para Colombia.",
  "7.	Las demás finalidades establecidas específicamente en las autorizaciones precontractuales, contractuales o post contractuales.",
  "8.	Las demás finalidades licitas de acuerdo con la legislación colombiana.",
];

export const customers = [
  "1.	Gestionar el proceso de vinculación y creación del cliente en la Compañía, para lo cual se requiere contar con documentos digitalizados y físicos de los clientes.",
  "2.	Generación de informes mensuales sobre el comportamiento de la cartera del cliente.",
  "3.	Prestar servicios crediticios a personas naturales y jurídicas a través de plataformas electrónicas.",
  "4.	Conocer su comportamiento financiero, comercial y crediticio y el cumplimiento de sus obligaciones legales.",
  "5.	Realizar ante los operadores de información (Experian, Transunion y/o cualquier otra entidad que llegue a manejar bases de datos con los mismos objetivos) la consulta de la información crediticia, así como el reporte de la generación, modificación, extinción, cumplimiento o incumplimiento de las obligaciones contraídas.",
  "6.	Compartir e intercambiar con sus entidades filiales, matrices, aliadas y/o con entidades financieras, cesionarios o inversionistas, la información personal y financiera, así como la información relacionada con créditos contratados u otorgados con o por la Compañía, contenida en las bases de datos de la entidad con fines de control de riesgos, cesión, desembolso y pago de obligaciones.",
  "7.	Compartir e intercambiar con aliados y terceros la información personal y financiera, así como la información relacionada con créditos contratados u otorgados con o por la Compañía con fines de publicidad y comerciales.",
  "8.	Realizar servicios legalmente autorizados bajo el contrato de mutuo firmado con nuestros clientes, como pueden ser cesiones de cartera, cobro de obligaciones y cualquier otra actividad autorizada en dicho contrato.",
  "9.	Adelantar contactos con fines comerciales, promocionales y de cobranza o cualquier otro relacionados con los servicios y productos de Galilea o los de terceros con los que la Compañía tenga relaciones comerciales o alianzas, a través de los canales autorizados por el cliente, los cuales podrán ser:",
  "a)	Correo electrónico, b)	Short Message Service (“SMS”, por sus siglas en inglés), c)	Multimedia Message Service (“MMS”, por sus siglas en inglés), d)	Unstructured Supplementary Service Data (“USSD”, por sus siglas en inglés), e)	WhatsApp, f)	Chats de redes sociales y aplicaciones asociadas al número telefónico registrado por el cliente, g)	Llamadas.",
  "Los contactos mencionados en este numeral serán realizados dentro de la franja horaria de lunes a viernes, entre las 7:00 am y las 7:00 pm, y los días sábado de 8:00 am a 3:00 pm, de conformidad con lo previsto en la Ley 2300 de 2023.",
  "10.	Realizar actividades de gestión de cobro, aviso de reporte a las centrales de riesgo, entrega de extractos de obligaciones y actualizar la información a través de diferentes actividades, como lo son la consulta en bases de datos públicas, páginas de internet y redes sociales.",
  "11.	Seguimiento de procesos jurídicos, identificación de pagos realizados y calificación de cartera de manera directa o a través de terceros ubicados dentro y fuera del territorio nacional.",
  "12.	Seguimiento continuo a nuestros clientes, mediante estrategias de fidelización efectivas propiciando confianza y lealtad para la prestación de nuevos servicios, con el propósito de dar a conocer a los clientes el portafolio de servicios crediticios que son ofrecidos a través de la Compañía.",
  "13.	Consultar y reportar información de los clientes a través de centrales de riesgo, de acuerdo con lo establecido en la Ley 1266 de 2008.",
  "14.	Mantener contacto con el Titular aun cuando finalice la relación contractual.",
  "15.	Compartir la información con terceros aliados que colaboran con la Compañía, tales como proveedores de servicios de mensajería, agencias de publicidad, casas de cobranzas, proveedores de productos, etc., considerando que para el cumplimiento de sus encargos deben acceder en alguna medida a la información, los cuales estarán igualmente sujetos a las obligaciones de confidencialidad, manejo de la información y protección de datos personales a las que está sujeto Galilea.",
  "16.	Dar atención y seguimiento a las solicitudes que reciba de los Titulares de Datos Personales, en ejercicio del derecho de Habeas data.",
  "17.	Gestión administrativa para la ejecución de las etapas precontractual, contractual y post contractual.",
  "18.	Evaluar la atención brindada al cliente y realizar actividades de prospección comercial.",
  "19.	Gestionar y dar atención oportuna a las peticiones, quejas o reclamos presentados por los clientes de la Compañía a través de los canales de servicio al cliente.",
  "20.	Dar cumplimiento al sistema de prevención de lavado de activos y financiación del terrorismo adoptado por la empresa y en consecuencia consultar al titular en listas restrictivas y vinculantes.",
  "21.	En todo caso, la información no será objeto de tratamiento por un período superior al tiempo que dure la relación contractual entre el cliente y la Compañía, y el tiempo adicional que se requiera de acuerdo con las circunstancias legales o contractuales que hagan necesario el manejo de la información.",
  "22.	Consultar en bases de datos internas y de terceros, la información proporcionada por el Usuario con el objetivo de establecer su nivel de riesgo.",
  "23.	Prestar los servicios ofrecidos por Galilea y aceptados en el contrato suscrito.",
  "24.	Suministrar la información a terceros con los cuales Galilea tenga relación contractual y que sea necesario entregársela para el cumplimiento del objeto contratado.",
  "25.	Efectuar las gestiones pertinentes para el desarrollo del objeto social de la compañía en lo que tiene que ver con el cumplimiento del objeto del contrato celebrado con el titular de la información.",
  "26.	Realizar comunicaciones y notificaciones en relación al crédito aprobado, invitaciones a eventos, ofrecer nuevos productos y servicios a través de diferentes campañas a través del envío de información a los medios de contacto suministrados por el titular de la información, como el envío de Short Message Service (“SMS” por sus siglas en inglés), correos electrónicos, mensajes vía WhatsApp, llamadas.",
  "27.	Gestionar trámites (solicitudes, quejas, reclamos).",
  "28.	Efectuar encuestas de satisfacción respecto de los bienes y servicios ofrecidos por Galilea.",
  "29.	Suministrar información de contacto a la fuerza comercial y/o red de distribución, telemercadeo, investigación de mercados y cualquier tercero con el cual Galilea tenga un vínculo contractual para el desarrollo de actividades de ese tipo (investigación de mercados y telemercadeo, etc) para la ejecución de las mismas. ",
  "30.	Contactar al titular a través de medios telefónicos y electrónicos proporcionados por este para realizar encuestas, estudios y/o confirmación de datos personales necesarios para la ejecución del contrato o su experiencia comercial con Galilea. ",
  "31.	Contactar al titular a través de medios electrónicos – “SMS” o chat para el envío de noticias relacionadas con campañas de fidelización o mejora de servicio. ",
  "32.	Contactar al titular a través de correo electrónico para el envío de notificación previa al reporte ante las centrales de riesgo, extractos, estados de cuenta o facturas en relación con las obligaciones derivadas del contrato celebrado entre las partes.",
  "33.	El Usuario titular autoriza a Galilea o a las personas que hagan sus veces, para que contrate con terceros localizados en Colombia o en el exterior, servicios relacionados con el procesamiento de datos, transmisión y almacenamiento de ordenes e información, para su utilización a escala nacional o internacional. ",
  "34.	El Usuario titular autoriza a Galilea, a compartir su información personal con sus aliados, filiales, matrices, cesionarios, compradores de cartera, tanto nacional como extranjeras para que realicen el tratamiento de su información como responsables o encargados del tratamiento de datos personales con todas las finalidades indicadas en el presente numeral. ",
  "35.	El Usuario titular autoriza a Galilea, sus aliados, filiales, matrices, cesionarios, compradores de cartera, tanto nacionales como extranjeros para mantener, compartir, suministrar, remitir, comercializar e intercambiar entre sí toda información sobre las condiciones personales, económicas y-o comerciales, y el comportamiento crediticio del Usuario con el fin que sean ofrecidos los productos y/o servicios propios del objeto social de Galilea o los productos y/o los servicios que prestan los terceros en ejercicio de sus objetos sociales y actividades comerciales lícitas o para propósitos legítimos de las partes definidos en este numeral.",
  "36.	El Usuario titular entiende que, en el evento que Galilea realice una venta de cartera o cesión a cualquier título a un tercero aliado, los efectos de la presente autorización le serán extendidos a dicho tercero en los mismos términos y condiciones, y para las mismas finalidades para las cuales autoriza el tratamiento de sus datos personales por parte de Galilea. De igual manera, en el evento que se realice una venta de cartera o cesión a cualquier título a un tercero aliado, este podrá́ ofrecer, de manera independiente o conjunta con terceros afiliados, servicios financieros, comerciales, de seguridad social y conexos, de mercadeo y publicidad a través de cualquier medio, así́ como realizar campañas de promoción, beneficencia o servicio social en conjunto con terceros. ",
  "37.	El Usuario titular en desarrollo de lo dispuesto en los artículos 8 y 13 de la Ley 1581 de 2012 y normas concordantes, autoriza a los operadores de información PILA para que hagan entrega a Galilea de la información relativa a sus ingresos y aportes a parafiscales. Para los efectos anteriores, otorgas poder especial, amplio y suficiente a Galilea para que reciba dicha información. ",
];

export const prospects = [
  "1.	Dar a conocer el portafolio de servicios crediticios que son comercializados por la Compañía.",
  "2.	Realizar seguimiento y perfilación en el proceso de adquisición de un crédito y actividades de prospección comercial.",
  "3.	Consultar al interesado en centrales de riesgo y con base en la Ley 1266 de 2008.",
  "4.	Mantener contacto con el Titular a través de canales físicos y digitales.",
  "5.	Realizar invitaciones a eventos y ofrecer nuevos productos y servicios.",
  "6.	Suministrar información de contacto a la fuerza comercial y/o red de distribución, y cualquier tercero con el cual la Compañía tenga un vínculo contractual para el desarrollo de la actividad de prospección comercial.",
  "7.	Adelantar contactos con fines comerciales y promocionales o cualquier otro relacionado con los servicios y productos de Galilea, o los de terceros con los que la Compañía tenga relaciones comerciales o alianzas, a través de los canales autorizados por el el prospecto, los cuales podrán ser",
  "a.	Correo electrónico, b.	Short Message Service (“SMS”, por sus siglas en inglés), c.	Multimedia Message Service (“MMS”, por sus siglas en inglés), d.	Unstructured Supplementary Service Data (“USSD”, por sus siglas en inglés), e.	WhatsApp, f.	Chats de redes sociales y aplicaciones asociadas al número telefónico registrado por el cliente, g.	Llamadas. ",
  "Los contactos mencionados en este numeral serán realizados dentro de la franja horaria de lunes a viernes, entre las 7:00 am y las 7:00 pm, y sábado de 8:00 am a 3:00 pm, de acuerdo con lo previsto en la Ley 2300 de 2023.",
  "8.	Dar cumplimiento al Sistema de prevención de lavado de activos y financiación del terrorismo adoptado por la empresa y, en consecuencia, consultar al titular en listas restrictivas y vinculantes.",
  "9.	En todo caso, la información será objeto de tratamiento por un período determinable, el cual es hasta la fecha de revocación del Titular del tratamiento de sus datos personales. ",
];

export const obligations = [
  "A.	Garantizar al titular el acceso, consulta, actualización, rectificación de sus datos personales.",
  "B.	Solicitar y conservar copia de la respectiva autorización para el tratamiento de datos personales informando la finalidad de la recolección.",
  "C.	Conservar la información bajo las condiciones de seguridad que impida la adulteración, pérdida, consulta, uso o acceso no autorizado o fraudulento.",
  "D.	Adoptar un manual interno de políticas que garanticen el cumplimiento de la Ley 1581 de 2012, relativa a la protección de datos personales.",
  "E.	Permitir el acceso a la información únicamente a las personas que deban tener acceso a ella.",
  "F.	Cumplir con las obligaciones establecidas en el artículo 18 de la Ley 1581 de 2012, y sus respectivos decretos reglamentarios, relativos a la protección de datos personales.",
  "G.	Cumplir a cabalidad con todas la obligaciones que la ley y normas de protección de datos personales le impongan.",
];

export const finalidades = [
  "1.	Dar a conocer el portafolio de servicios crediticios que son comercializados por la Compañía o por terceros que ofrecen servicios similares o diferentes a Galilea.",
  "2.	Realizar seguimiento y perfilación en el proceso de adquisición de un crédito y actividades de prospección comercial.",
  "3.	Consultar al interesado en centrales de riesgo y con base en la Ley 1266 de 2008.",
  "4.	Mantener contacto con el Titular a través de canales físicos y digitales.",
  "5.	Realizar invitaciones a eventos y ofrecer nuevos productos y servicios.",
  "6.	Suministrar información de contacto a la fuerza comercial y/o red de distribución, y cualquier tercero con el cual la Compañía tenga un vínculo contractual para el desarrollo de la actividad de prospección comercial.",
  "7.	Adelantar contactos con fines comerciales y promocionales o cualquier otro relacionado con los servicios y productos de Galilea, o los de terceros con los que la Compañía tenga relaciones comerciales o alianzas, a través de los canales autorizados por el el prospecto, los cuales podrán ser:",
];

export const canalesAutorizados = [
  "a.	Correo electrónico,",
  "b.	Short Message Service (“SMS”, por sus siglas en inglés),",
  "c.	Multimedia Message Service (“MMS”, por sus siglas en inglés),",
  "d.	Unstructured Supplementary Service Data (“USSD”, por sus siglas en inglés),",
  "e.	WhatsApp,",
  "f.	Chats de redes sociales y aplicaciones asociadas al número telefónico registrado por el cliente,",
  "g.	Llamadas.",
];

export const rights = [
  "●	Acceder en forma gratuita a sus datos personales que hayan sido objeto de Tratamiento.",
  "●	Conocer, actualizar y rectificar su información. Este derecho se podrá ejercer, entre otros frente a datos parciales, inexactos, incompletos, fraccionados, que induzcan a error, o aquellos cuyo tratamiento esté expresamente prohibido o no haya sido autorizado.",
  "●	Conocer por qué y para qué Galilea, recolecta información en base de datos.",
  "●	Revocar la autorización dada para contener información personal en las bases de datos de Galilea y/o solicitar la supresión del dato siempre que no exista un deber legal o contractual que impida eliminarlos.",
  "●	Presentar queja ante la Superintendencia de Industria y Comercio, cuando Galilea no haya atendido satisfactoriamente consultas o reclamos.",
  "●	Solicitar prueba de la autorización otorgada al responsable del tratamiento salvo cuando expresamente se exceptúe como requisito para el tratamiento, de conformidad con lo previsto en el artículo 10 de la Ley 1581 de 2012. ",
  "●	Abstenerse de responder las preguntas sobre datos sensibles tendrá carácter facultativo las respuestas que versen sobre datos sensibles o sobre datos de los niños y niñas y adolescentes.",
];

export const apts = [
  "1.	Proveedores o contratistas",
  "2.	Empleados",
  "3.	Aspirantes",
  "4.	Clientes",
];

export const dataApts = [
  "A.	Nombres y apellidos completos.",
  "B.	Tipo y número de identificación.",
  "C.	Datos de contacto (Dirección física y/o electrónica y teléfonos de contacto).",
  "D.	Medios para recibir respuesta a su solicitud.",
  "E.	Motivo(s)/hecho(s) que dan lugar al reclamo con una breve descripción del derecho que desea ejercer (conocer, actualizar, rectificar, solicitar prueba de la autorización otorgada, revocarla, suprimir, acceder a la información).",
];

export const docsApts = [
  "1.	Fotocopia de su documento de identidad.",
  "2.	Carta autenticada de acreditación de causahabiente.",
  "3.	Carta autenticada de representación o apoderamiento.",
  "4.	Otro documento que acredite la facultad de representación del titular de los datos.",
];

export const imgApts = [
  "A.	Indicar los hechos de la solicitud, estableciendo fecha, hora, lugar y demás información que facilite la ubicación del fragmento de imagen o video.",
  "B.	Justificar la necesidad de la solicitud.",
  "C.	Aportar los documentos que permitan justificar que el titular es la persona indicada para realizar dicha solicitud. En caso de que el interesado sea un tercero, deberá aportar el documento de autorización para el acceso a esa información por parte del titular del dato.",
];

export const processImg = [
  "●	Verificará que la información aún se encuentre almacenada en sus servidores.",
  "●	Revisará dicha solicitud, y verificará si es procedente, revisando que no afecte el derecho a la intimidad, y otros derechos fundamentales de terceras personas, diferentes al titular de la información que se encuentren en dichas imágenes y/o video.",
  "●	En caso de que afecte derechos de terceros, Galilea notificará que dentro de la información solicitada se encuentran imágenes de terceros, por lo cual se requiere realizar la anonimización (hacer borrosa o fragmentar) de los datos. Los costos de dicho proceso de anonimización deben ser cancelados por el solicitante. ",
  "●	En caso de que no afecte derechos fundamentales de terceros, Galilea citará al titular de la información en sus instalaciones para que pueda visualizar la información que requiere. ",
];

export function PersonalDataV2() {
  return (
    <>
      <div className="bg-purpleLight relative sm:px-6 lg:px-8">
        <div className="bg-white max-w-3xl mx-auto px-4 pb-6">
          <div className="text-lg pt-6 max-w-prose mx-auto">
            <h1 className="mt-2 block text-xl text-center font-bold sm:text-4xl">
              CAPÍTULO I
            </h1>

            <div className="text-sm lg:text-xl">
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  DISPOSICIONES GENERALES:
                </span>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  1.1 Identificación del responsable de tratamiento.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El Responsable del tratamiento de datos personales{" "}
                    <span className="font-bold">
                      GRUPO EMPRESARIAL ANAV S.A.S.
                    </span>{" "}
                    (en adelante “Galilea”) es una empresa constituida y
                    existente bajo las leyes de la República de Colombia, y
                    quien de acuerdo a la autorización previa y expresa de los
                    titulares de la información, actúa como responsable del
                    tratamiento de información personal. Para todos los efectos
                    del tratamiento de datos personales, los datos de
                    identificación de Galilea son los siguientes:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {companyDatas.map((companyData) => (
                    <ul role="list" className="marker:text-purple list-disc">
                      <div key={companyData} className="pl-6 grid grid-cols-5">
                        <div className="col-span-2">
                          <li>{companyData.title}</li>
                        </div>
                        <div className="col-span-3">
                          <span>{companyData.value}</span>
                        </div>
                      </div>
                    </ul>
                  ))}
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">1.2 Definiciones.</span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">Autorización:</span>{" "}
                    consentimiento previo, expreso e informado del Titular
                    (definido más adelante) para llevar a cabo el Tratamiento de
                    datos personales.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">Base de Datos:</span> conjunto
                    organizado de datos personales que sea objeto de
                    Tratamiento.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">Dato Personal:</span> cualquier
                    información vinculada o que pueda asociarse a una o a varias
                    personas naturales determinadas o determinables.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">Dato Semiprivado:</span> son
                    aquellos datos que no tienen una naturaleza íntima,
                    reservada, ni pública y cuyo conocimiento o divulgación
                    puede interesar no solo a su titular, sino a un grupo de
                    personas o a la sociedad en general. A modo de ejemplo, pero
                    sin limitarse, se entiende por Datos Semiprivados, los datos
                    de carácter financiero, datos relativos a las relaciones con
                    las entidades de seguridad social, Empresas Promotoras de
                    Salud (“EPS”), Administradoras de Fondos Pensionales (AFP”),
                    Administradora de Riesgos Laborales (“ARL”), Cajas de
                    Compensación, entre otras.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">Dato Sensible:</span> son
                    aquellos que afectan la intimidad del Titular o cuyo uso
                    indebido puede generar su discriminación, tales como
                    aquellos que revelen el origen racial o étnico, la
                    orientación política, las convicciones religiosas o
                    filosóficas, la pertenencia a sindicatos, organizaciones
                    sociales, de derechos humanos o que promueva intereses de
                    cualquier partido político o que garanticen los derechos y
                    garantías de partidos políticos de oposición así como los
                    datos relativos a la salud, a la vida sexual y los datos
                    biométricos.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">Dato Privado:</span> es un dato
                    personal que por su naturaleza íntima o reservada solo
                    interesa a su Titular y para su tratamiento requiere de su
                    autorización expresa. A modo de ejemplo, pero sin limitarlo,
                    el nivel de escolaridad, entre otros.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">Dato Público:</span> es aquel
                    tipo de Dato Personal que las normas y la Constitución han
                    determinado expresamente como públicos y, para cuya
                    recolección y tratamiento, no es necesaria la autorización
                    del Titular de la información. A modo de ejemplo, pero sin
                    limitarlo, estado civil de las personas, datos contenidos en
                    sentencias judiciales ejecutoriadas, entre otros.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">
                      Encargado del Tratamiento:
                    </span>{" "}
                    persona natural o jurídica, pública o privada, que por sí
                    misma o en asocio con otros, realice el Tratamiento de Datos
                    Personales por cuenta del Responsable del Tratamiento.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">
                      Responsable del Tratamiento:
                    </span>{" "}
                    persona natural o jurídica, pública o privada, que por sí
                    misma o en asocio con otros, decida sobre la Base de Datos
                    y/o el Tratamiento de los datos.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">Titular:</span> persona natural
                    cuyos Datos Personales sean objeto de Tratamiento y ha
                    brindado autorización previa y expresa a Galilea para su
                    Tratamiento.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">Tratamiento:</span> cualquier
                    operación o conjunto de operaciones sobre Datos Personales,
                    tales como, pero sin limitarlo, la recolección,
                    almacenamiento, uso, circulación o supresión.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">Transferencia:</span> La
                    transferencia de datos tiene lugar cuando el Responsable y/o
                    Encargado del Tratamiento de Datos Personales, ubicado en
                    Colombia, envía la información o los Datos Personales a un
                    receptor, que a su vez es Responsable del Tratamiento y se
                    encuentra dentro o fuera del país.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">Transmisión:</span> Tratamiento
                    de Datos Personales que implica la comunicación de estos
                    dentro o fuera del territorio de la República de Colombia
                    cuando tenga por objeto la realización de un Tratamiento por
                    el Encargado por cuenta del Responsable.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">Transmisión:</span> Tratamiento
                    de Datos Personales que implica la comunicación de estos
                    dentro o fuera del territorio de la República de Colombia
                    cuando tenga por objeto la realización de un Tratamiento por
                    el Encargado por cuenta del Responsable.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  1.3 Objeto de la política.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    La presente Política de Tratamiento de Datos Personales (en
                    adelante la “Política”) tiene como propósito establecer los
                    criterios bajo los cuales se realiza el Tratamiento de la
                    información personal que reposa en las bases de datos,
                    archivos físicos y digitales de Galilea, dando así
                    cumplimiento a lo establecido en la legislación colombiana
                    referente al Tratamiento de Datos Personales.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  1.4 Alcance de la política.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Esta política aplica para todos los Datos Personales
                    registrados en las Bases de Datos de Galilea, quien actúa en
                    calidad de Responsable del Tratamiento. Así mismo, establece
                    los criterios que Galilea ha incorporado para el Tratamiento
                    de los Datos Personales, los mecanismos para que los
                    Titulares puedan ejercer sus derechos, las finalidades, las
                    medidas de seguridad, y otros aspectos relacionados con la
                    protección de la información personal.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    La presente Política está dirigida a cualquier Titular de la
                    información o aquel que actúe como su representante legal y
                    del cual Galilea haya requerido información personal para el
                    desarrollo de alguna actividad.
                  </span>
                </div>
              </div>
            </div>
            <h1 className="mt-2 pt-4 block text-xl text-center font-bold sm:text-4xl">
              CAPÍTULO II
            </h1>
            <div className="text-sm lg:text-xl">
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">TRATAMIENTO DE DATOS:</span>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  2.1. Tipos de Datos Personales tratados.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea en el desarrollo de su objeto social, puede
                    solicitarle al Titular la autorización para el Tratamiento
                    de sus Datos Personales, los cuales pueden ser catalogados
                    como Públicos, Semi Privados, Privados o Sensibles, estos
                    Datos son autorizados para su Tratamiento de manera expresa
                    y previa por parte de los Titulares.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Entre los datos que puede solicitar Galilea tenemos los
                    siguientes: (i) académicos, (ii) contacto, tales como numero
                    de celular, correo electrónico o dirección de residencia,
                    (iii) datos financieros o laborales, ingresos y egresos
                    mensuales, (iv) datos públicos, (v) en fin, todos los datos
                    necesarios para la evaluación de riesgo y aquellos que le
                    permita a Galilea mantenerse en contacto con el Titular en
                    vigencia de la ejecución del servicio ofrecido por Galilea.
                    Sin perjuicio de lo anterior, Galilea trata los Datos
                    Personales de acuerdo con las finalidades aceptadas y
                    autorizadas por el Titular, razón por la cual, a pesar que
                    no exista un servicio vigente, Galilea puede seguir
                    contactando al Titular para brindarle diferentes
                    alternativas de servicios propios o de terceros aliados de
                    Galilea.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  2.2. Tipos de Datos Personales tratados.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Los Datos Personales que son obtenidos por Galilea están
                    sometidos a los siguientes tratamientos:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block font-bold">● Recolección.</span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block ">
                    Galilea recolecta información personal a través de diversos
                    medios en el desarrollo de las diferentes actividades
                    relacionadas con su objeto social, y las obligaciones que
                    tiene como empleador. La información personal será obtenida
                    de tres formas diferentes: a) directamente del Titular a
                    través del formulario de solicitud del crédito, b) de un
                    tercero siempre y cuando este cuente con la autorización
                    previa y expresa por parte del Titular y c) de fuentes
                    públicas de información.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block ">
                    Así mismo la recolección de información personal podrá
                    llevarse a cabo a través de medios físicos, digitales o
                    electrónicos, y en cada uno de ellos se incorporará un aviso
                    de privacidad y autorización, dando así cumplimiento a los
                    requisitos establecidos en el art. 2.2.2.25.3.2 y
                    2.2.2.25.3.3 del decreto 1074 y obedeciendo los principios
                    de libertad y finalidad del art. 4 de la Ley 1581 de 2012.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block font-bold">● Almacenamiento.</span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block ">
                    El almacenamiento de la información personal contenida en
                    las bases de datos o sistemas de información se encuentra en
                    los servidores propios dentro del país, y en servidores
                    externos de terceros, los cuales cuentan con medidas de
                    seguridad física, técnicas y administrativas, y cuenta con
                    controles de acceso a la información, garantizando el
                    principio de acceso y circulación restringida.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block ">
                    La información personal que se encuentre sujeta a
                    requerimientos de Ley permanecerá almacenada en nuestras
                    bases de datos de acuerdo con lo que para esto la Ley haya
                    establecido, en aquellos casos donde la Ley no se ha
                    pronunciado la información permanecerá mientras que la
                    finalidad para la cual fue recolectada se encuentre vigente.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block font-bold">● Circulación.</span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block ">
                    Por regla general, Galilea no comparte los datos personales
                    que recolecta con terceros no autorizados. No obstante, para el
                    cumplimiento efectivo de sus obligaciones puede entregar los
                    datos a otras entidades, amparados en los artículos
                    2.2.2.25.5.1 y 2.2.2.25.5.2 del decreto 1074 que establece
                    que se encuentra permitido la transmisión de datos
                    personales cuando sea necesario para la ejecución de un
                    contrato entre el titular y el responsable del tratamiento,
                    o para la ejecución de medidas precontractuales siempre y
                    cuando se cuente con la autorización del titular o exista un
                    contrato de transmisión de datos personales.
                    Sin perjuicio de lo anterior, Galilea está
                    autorizada por el Titular para que comparta su información personal con terceros
                    que puedan brindarle productos financieros iguales o similares a Galilea,
                    todo lo anterior en concordancia con las finalidades de la recolección
                    indicadas expresamente en la presente Política.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block font-bold">● Supresión.</span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block ">
                    La supresión de la información personal que haya sido
                    recolectada se llevará a cabo cuando: (I) no sea necesaria
                    para el cumplimiento de aspectos legales, contractuales,
                    tributarios, financieros, de auditoría o esté cubierta por
                    disposiciones o requerimientos de Ley, (II) No afecte o
                    implique la perdida de trazabilidad o integridad de las
                    bases de datos o sistemas de información donde reposa la
                    información; (III) Se haya cumplido o eliminado la finalidad
                    para la cual fueron recolectados. (IV) Sea solicitada por el
                    titular de los datos o aquel que demuestre que se encuentra
                    autorizado y no vaya en contra de las definiciones
                    anteriores. No obstante, pueda que alguna información se
                    conserve únicamente con fines estadísticos o de auditoría.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  2.3. Usos o finalidades de la recolección de información.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea realiza el tratamiento de los datos personales de
                    sus Usuarios en concordancia con lo dispuesto en la Ley 1581
                    de 2012, Ley 1266 de 2008, decretos reglamentarios y todas
                    las normas referentes al tratamiento de datos personales en
                    Colombia. El Usuario tiene derecho a conocer, actualizar y
                    rectificar su información personal en cualquier momento.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea será el Responsable del tratamiento de datos
                    personales y, en tal virtud, podrá recolectar, almacenar,
                    usar, consultar, reportar ante las centrales de riesgo
                    financieras y terceros la información recolectada del
                    Usuario.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El uso o finalidad que se da a la información personal
                    recolectada de cada tipo de titular es:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">
                      2.3.1 PROVEEDORES O CONTRATISTAS.
                    </span>{" "}
                    Galilea recolecta los datos personales de sus proveedores o
                    contratistas (en adelante “contrapartes”) y los almacena en
                    una base de datos de uso interno. Esta base de datos puede
                    contener datos considerados por Galilea como reservados, en
                    virtud que se trata de personas naturales o jurídicas que le
                    proveen servicios o tecnología para cumplir con su objeto
                    social. Esta información al ser reservada podrá ser revelada
                    por Galilea con la autorización de la Contraparte o mediante
                    orden de autoridad competente. La finalidad para la cual es
                    recolecta la información de las Contraparte, entre otras,
                    son:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {partners.map((partner) => (
                    <>
                      <div key={partner} className="block pt-4 lg:pt-8">
                        {partner}
                      </div>
                    </>
                  ))}
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">2.3.2 EMPLEADOS.</span> Galilea
                    recolecta los datos personales de su trabajadores y
                    aprendices (para efectos del presente documento se
                    denominarán “trabajadores”), los cuales permanecen en una
                    base de datos de propiedad de Galilea, los cuales son
                    considerados y catalogados como reservados. Estos datos solo
                    podrán ser conocidos por terceros con la autorización
                    expresa de su Titular o por mediante orden de autoridad
                    competente. La finalidad para la cual es recolecta la
                    información de los empleados, entre otras, son:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {employees.map((employee) => (
                    <>
                      <div key={employee} className="block pt-4 lg:pt-8">
                        {employee}
                      </div>
                    </>
                  ))}
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">2.3.3 ASPIRANTES.</span> Los
                    Datos Personales de los aspirantes a alguna vacante ofertada
                    por Galilea, podrán ser recolectados en un base de datos de
                    talento humano, la cual podrá ser tratada por Galilea para
                    presentes o futuros proceso de selección en los que el
                    perfil del aspirante se adecue. Las finalidades de la
                    recolección y tratamientos de sus datos personales,
                    consisten en:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {applicants.map((applicant) => (
                    <>
                      <div key={applicant} className="block pt-4 lg:pt-8">
                        {applicant}
                      </div>
                    </>
                  ))}
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">2.3.4 CLIENTES.</span> La
                    Compañía recolecta los datos personales de sus clientes y
                    los almacena en una base de datos, la cual es calificada por
                    Galilea como de reservada, y solo será revelada con la
                    expresa autorización del Titular o cuando una autoridad
                    competente lo solicite. Las finalidades para las cuales son
                    utilizados los datos personales de los clientes de la
                    Compañía, entre otros, son:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {customers.map((customer) => (
                    <>
                      <div key={customer} className="block pt-4 lg:pt-8">
                        {customer}
                      </div>
                    </>
                  ))}
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    <span className="font-bold">
                      2.3.5 TRATAMIENTO DE DATOS PERSONALES DE PROSPECTOS.
                    </span>{" "}
                    La Compañía
                    recolecta los datos personales de prospectos y los almacena en una base de datos. Galilea está
                    autorizada por el Titular para que comparta su información personal con terceros que puedan

                    brindarle productos financieros iguales o similares a Galilea, de acuerdo con las siguientes
                    finalidades:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {finalidades.map((finalidad) => (
                    <>
                      <div className="pt-4 lg:pt-8" key={finalidad}>
                        {finalidad}
                      </div>
                    </>
                  ))}
                </div>
                <div className="pt-4 lg:pt-8 ml-4">
                  {canalesAutorizados.map((canal) => (
                    <>
                      <div className="pt-4 lg:pt-8" key={canal}>
                        {canal}
                      </div>
                    </>
                  ))}
                </div>

                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Los contactos mencionados en este numeral serán realizados dentro de la franja horaria
                    de lunes a viernes, entre las 7:00 am y las 7:00 pm, y sábado de 8:00 am a 3:00 pm, de
                    acuerdo con lo previsto en la Ley 2300 de 2023.
                  </span>
                </div>

                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    8. Dar cumplimiento al Sistema de prevención de lavado de activos y financiación del
                    terrorismo adoptado por la empresa y, en consecuencia, consultar al titular en listas
                    restrictivas y vinculantes.
                  </span>
                </div>

                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    9. En todo caso, la información será objeto de tratamiento por un período determinable,
                    el cual es hasta la fecha de revocación del Titular del tratamiento de sus datos
                    personales.
                  </span>
                </div>

              </div>

              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  2.4. Autorización para el tratamiento de datos.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea solicitará de manera libre, previa, expresa y
                    debidamente informada, la autorización por parte de los
                    Titulares de los Datos Personales y para ello generará
                    mecanismos idóneos garantizando para cada caso que sea
                    posible verificar el otorgamiento de dicha autorización. La
                    misma, podrá constar en cualquier medio, bien sea un
                    documento físico, digital, electrónico o en cualquier
                    formato que garantice su posterior consulta a través de
                    herramientas técnicas, cumpliendo con los requisitos
                    establecidos en la Ley.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    ● Autorización tratamiento de datos niños, niñas y
                    adolescentes.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    En el Tratamiento de datos personales de niños, niñas y
                    adolescentes se asegurará el respeto a los derechos de los
                    menores de edad. Galilea podrá requerir el tratamiento de
                    datos personales de menores de edad para dar cumplimiento a
                    aspectos legales como: I) El artículo 32 de la Ley 789 de
                    2002 relacionado con la obligación de adelantar la
                    vinculación de aprendices y II) El derecho de los afiliados
                    al Sistema de Seguridad Social de afiliar a cualquier
                    pariente dentro del tercer grado de consanguinidad o a
                    cualquier menor de 12 años (sea o no pariente) siempre y
                    cuando dependa económicamente.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    En caso de requerir la recolección directa de datos
                    personales de niños, niñas y adolescentes, Galilea
                    solicitará la autorización de tratamiento con el
                    consentimiento informado de los padres o adultos
                    responsables de los menores de edad.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  2.5. Medidas de seguridad y protección.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea ha adoptado las medidas técnicas, jurídicas,
                    humanas, tecnológicas y administrativas necesarias para
                    procurar la seguridad de los datos de carácter personal
                    protegiendo la confidencialidad, integridad, uso, acceso no
                    autorizado y/o fraudulento. Así mismo, internamente se han
                    implementado protocolos y lineamientos de seguridad de
                    obligatorio cumplimiento para todo el personal con acceso a
                    datos de carácter personal y a los sistemas de información.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  2.6 Obligaciones de los encargados de la información personal.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Las empresas y/o personas externas a Galilea, que en virtud
                    de una relación contractual realice el tratamiento de datos
                    personales, deberá cumplir con las siguientes obligaciones:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {obligations.map((obligation) => (
                    <>
                      <div className="pt-4 lg:pt-8" key={obligation}>
                        {obligation}
                      </div>
                    </>
                  ))}
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  2.7 En caso de operar como encargado de la información.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    En los casos de que Galilea opere como encargado de la
                    información, los Responsables de la información deberán
                    solicitar y conservar la autorización del titular de la
                    información, para el tratamiento de los datos personales por
                    parte nuestra. Galilea presume que el Responsable de la
                    información, cuenta con las autorizaciones previas y
                    expresas de los titulares con quien tiene contacto, para
                    hacer uso de sus datos personales y suministrará copia de
                    tales autorizaciones en caso de que como encargados lo
                    requiramos, para los fines consagrados en la política de
                    tratamiento de datos personales.
                  </span>
                </div>
              </div>
            </div>
            <h1 className="mt-2 pt-4 block text-xl text-center font-bold sm:text-4xl">
              CAPÍTULO III
            </h1>
            <div className="text-sm lg:text-xl">
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">GESTIÓN DE DERECHOS:</span>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  3.1 Derechos de los titulares.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El Derecho Fundamental al Habeas Data, faculta al titular
                    del dato solicitar el acceso, actualización, rectificación y
                    supresión de sus datos personales que se encuentran en
                    posesión de un tercero, a su vez, puede revocar la
                    autorización que ha otorgado para el tratamiento. Si un
                    titular de datos personales considera que Galilea tiene
                    acceso a sus datos personales, esta persona puede en todo
                    momento solicitar la consulta de sus datos, o si considera
                    que Galilea está haciendo mal uso de sus datos, puede
                    realizar la respectiva reclamación. El titular está
                    facultado para solicitar:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {rights.map((right) => (
                    <>
                      <div className="pt-4 lg:pt-8" key={right}>
                        {right}{" "}
                      </div>
                    </>
                  ))}
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  3.2 Tiempos de atención.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">3.2.1 Consulta.</span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    A través del mecanismo de la consulta, el titular del dato
                    podrá solicitar a Galilea, acceso a su información personal.
                    La consulta será atendida en un término máximo de diez (10)
                    días hábiles contados a partir de la fecha de recibo de
                    esta. En caso de no ser posible dar respuesta a la consulta
                    dentro del término referenciado, se le informará, los
                    motivos de la demora y se le dará respuesta, máximo cinco
                    (5) días hábiles siguientes al vencimiento del primer
                    término.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">3.2.2 Reclamos.</span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    A través del mecanismo de reclamo, el titular del dato podrá
                    reclamar a Galilea, alguna inconformidad que tenga sobre el
                    uso que se le está dando a sus datos.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El reclamo será atendido en un término máximo de (15) quince
                    días hábiles contados a partir del día siguiente a la fecha
                    de su recibo. En caso de no ser posible atender el reclamo
                    dentro de dicho término se le informará, los motivos de la
                    demora y se le dará respuesta máxima (8) ocho días hábiles
                    siguientes al vencimiento del primer término.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    En caso de que el reclamo se encuentre incompleto, se le
                    requerirá, dentro de los cinco (5) días siguientes a la
                    recepción del reclamo para que subsane las fallas.
                    Transcurridos dos (2) meses desde la fecha del
                    requerimiento, sin que presente la información requerida, se
                    entenderá que ha desistido del reclamo. Cuando Galilea no
                    sea competente para resolver el reclamo, dará traslado a
                    quien corresponda en un término máximo de dos (2) días
                    hábiles e informará de la situación al titular.
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">
                  3.3 Procedimiento para ejercer los derechos como titular de
                  los datos.
                </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    ● Titulares o personas facultadas para ejercer los derechos.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Podrá ejercer sus derechos cualquier titular de la
                    información o aquel que actúe como su representante legal.
                    Los siguientes titulares son meramente con carácter
                    ejemplificativo y no son exclusivos, ni excluyentes.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {apts.map((apt) => (
                    <>
                      <div key={apt}>{apt}</div>
                    </>
                  ))}
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    ● Información que debe acreditar el titular o persona.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Para el radicado y atención de su solicitud le solicitamos
                    suministrar la siguiente información:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {dataApts.map((dataApt) => (
                    <>
                      <div key={dataApt}>{dataApt}</div>
                    </>
                  ))}
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Todo ejercicio de sus derechos requiere de legitimación
                    previa, de acuerdo con lo descrito en el artículo
                    2.2.2.25.4.1 de decreto 1074, por lo cual toda petición o
                    reclamo asociados a solicitudes de acceso, rectificación,
                    actualización o eliminación de datos deberá estar acompañada
                    de cualquiera de los siguientes documentos:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {docsApts.map((docsApt) => (
                    <>
                      <div key={docsApt}>{docsApt}</div>
                    </>
                  ))}
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">Solicitud de imágenes o videos.</span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    En caso de que el titular de la información solicite acceso
                    a imágenes y/o videos donde se capture su información,
                    deberá seguir el siguiente procedimiento:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {imgApts.map((imgApt) => (
                    <>
                      <div key={imgApt}>{imgApt}</div>
                    </>
                  ))}
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    ● Procedimiento para trámites por solicitud de imágenes y/o
                    videos.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Para que proceda el trámite, Galilea:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {processImg.map((processIm) => (
                    <>
                      <div key={processIm}>{processIm}</div>
                    </>
                  ))}
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">3.4 Canales de atención</span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El Usuario, podrá ejercer su derecho de información respecto
                    al crédito a su cargo y a interponer peticiones, quejas y
                    reclamos por las condiciones que considere necesarias y
                    pertinentes, en los siguientes canales:
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  {contacts.map((contact) => (
                    <>
                      <div className="pt-4 lg:pt-8" key={contact.title}>
                        <div className="block">{contact.title}</div>
                        <div className="font-bold">{contact.value} </div>
                      </div>
                    </>
                  ))}
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block font-bold">
                    Responsable del cumplimiento de la política.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    El responsable del efectivo cumplimiento de la Política, así
                    como de las consultas y reclamos relacionados con la
                    protección de datos personales de los titulares en Galilea
                    será el área Jurídica de la sociedad. En todo caso el
                    responsable, podrá requerir otras áreas de Galilea para
                    efectos de verificar el cumplimiento de la normativa
                    relativa a protección de datos personales. En caso de
                    cualquier duda respecto a esta política, puede contactarnos
                    a través de los canales anteriormente descritos.
                  </span>
                </div>
              </div>
            </div>
            <h1 className="mt-2 pt-4 block text-xl text-center font-bold sm:text-4xl">
              CAPÍTULO IV
            </h1>
            <div className="text-sm lg:text-xl">
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">ASPECTOS FINALES:</span>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">4.1 Disposiciones.</span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">● Medidas permanentes.</span>
                </div>
                <div className="">
                  <span className="block">
                    En el tratamiento de datos personales, Galilea de manera
                    permanente, verificará en sus procesos, protocolos,
                    procedimientos y políticas, que se garantice el derecho de
                    hábeas data a los titulares de la información.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">● Vínculo con la política.</span>
                </div>
                <div className="">
                  <span className="block">
                    Cualquier titular de la información que tenga alguna
                    relación con Galilea, deberá acatar la presente política.
                    Los titulares de la información, diferente a los usuarios
                    finales, deberán cumplir con el manual interno de políticas
                    relativas a la protección de datos personales.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    ● Cumplimiento de los principios.
                  </span>
                </div>
                <div className="">
                  <span className="block">
                    Galilea garantiza los principios de legalidad, finalidad,
                    libertad, veracidad o calidad, transparencia, acceso y
                    circulación restringida, seguridad y confidencialidad sobre
                    los datos que reposan en las bases de datos de Galilea.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    ● Inscripción de las bases de datos en el RNBD.
                  </span>
                </div>
                <div className="">
                  <span className="block">
                    Dando cumplimiento a las disposiciones normativas, Galilea
                    llevará a cabo la inscripción de las bases de datos que
                    tiene en posesión de acuerdo con lo descrito en el Decreto
                    090 de enero de 2018, el cual modifica y redefine los
                    artículos 2.2.2.26.1.2 Ámbito de Aplicación y 2.2.2.26.3.1
                    Plazo de Inscripción del Decreto 1074 de 2015.
                  </span>
                </div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">● Permanencia.</span>
                </div>
                <div className="">
                  <span className="block">
                    Las bases de datos en las que se registrarán los datos
                    personales tendrán una vigencia igual al tiempo en que se
                    mantenga y utilice la información para las finalidades
                    descritas en esta política. Los datos personales
                    proporcionados se conservarán mientras se mantenga la
                    relación contractual con el Titular de la información o
                    mientras no se solicite su supresión por el interesado y
                    siempre que no exista un deber legal de conservarlo
                  </span>
                </div>
              </div>
              <div className="pt-4 lg:pt-8">
                <span className="block font-bold">4.2 Cambios y Vigencia </span>
              </div>
              <div>
                <div className="pt-4 lg:pt-8">
                  <span className="block">
                    Galilea se compromete a efectuar la debida comunicación a
                    los titulares de la información, cualquier modificación,
                    adición o supresión a la presente política y la fecha de
                    entrada en vigor. La presente Política de Privacidad y
                    Tratamiento de la Información entra en vigor a partir del
                    30/08/2024 en su versión No.02.{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
